<template>
  <el-col :span="24" ref="trxContainer">
    <el-row type="flex" justify="start" align="middle" class="v-padded-s trx-title-container" ref="trxTitleContainer">
      <el-col :span="12" class="h-padded left-aligned-col">
        <el-row type="flex" align="middle" justify="start">
          <h2 style="margin: 0; font-weight: 100;">
            {{ hasEditPermission ? 'EDIT' : 'VIEW'}} AP ENTRY {{ (form && form.hasOwnProperty('number') && form.number) ? form.number : '' }}
            ({{
              originalHeader && originalHeader.hasOwnProperty('status') && originalHeader.status
                ? originalHeader.status
                : ''
            }})
          </h2>
        </el-row>
      </el-col>
      <template>
        <el-button :disabled="disablePrevButton || isSaving" :loading="loadingPrev" @click.stop="pageNavigation('prev')" size="small">Previous</el-button>
        <el-button :disabled="disableNextButton || isSaving" class="mr-5" :loading="loadingNext" @click.stop="pageNavigation('next')" size="small">Next</el-button>
      </template>
      <DataEntryButtons
        :showProscanToggle="true"
        :proscanFileVisible="proscanFileVisible"
        @toggleProscanFile="toggleProscanFile"
        :status="originalHeader.status"
        :isReadOnly="readOnly"
        :isBalanced="transactionIsBalanced"
        :isSaving="isSaving"
        :isPaid = 'originalHeader.is_paid'
        :isSaveable="isSaveable"
        :hasBeenChanged="hasBeenChanged"
        :disableDistChanges="disableDistChanges"
        :disableAuditBtn="disableAuditBtn"
        :disablePostBtn="disablePostBtn"
        :transactionType="transactionType"
        :allowDraftFileUpload="true"
        :numberOfFiles="numberOfFiles"
        :isRecon="isRecon"
        :hasPermission="hasPermission"
        @addNew="addNew"
        @toggleReadOnly="toggleReadOnly"
        @dropdownClick="handleDropdownClick"
        @goBack="goBack"
        @auditBtnClick="handleAuditBtnClick('Accounts Payable')"
        @postBtnClick="handlePostBtnClick('Accounts Payable')"
        @otherActions="otherActions"
        @submit="handleSubmit"
      />
    </el-row>
    <el-row type="flex" ref="mockTrxTitleContainer" />
      <el-row justify="start" align="top" type="flex" class="trx-header" ref="trxHeaderContainer">
        <el-col :span="10" v-if="showProscanFile" class="proscan-pane-col">
          <ProscanFileViewer
            class="proscan-pane"
            :files="proscanFiles"
            :transactionNumber="originalHeader.number"
            :primaryFileId="proscanFileId" />
        </el-col>
        <el-col :span="showProscanFile ? 14 : 24">
        <el-row justify="start" align="top" :type="showProscanFile ? '' : 'flex'">
      <el-col :span="showProscanFile ? 24 : 8" class="left-aligned-col">
        <el-row justify="start" align="top" type="flex">
          <HeaderFields
            title="Vendor"
            :openCreateModal="openCreateModal"
            :fields="fields.vendor"
            :form="form"
            :idPrefix="'a-'"
            :modalOpen="dialogVisible"
            :isSaving="isSaving"
            :linesContainReliefLines="linesContainReliefLines"
            @formChanged="updateForm"
          />
        </el-row>
        <el-row justify="start" align="middle" type="flex">
          <HeaderFields
            title="Batch"
            :fields="fields.batch"
            :form="form"
            :idPrefix="'b-'"
            :modalOpen="dialogVisible"
            :isSaving="isSaving"
            @formChanged="updateForm"
          />
        </el-row>
      </el-col>
      <el-col :span="showProscanFile ? 24 : 8" :style="showProscanFile ? '' : 'padding: 0 10px;'">
        <el-row justify="start" align="middle" type="flex">
          <HeaderFields
            title="Invoice Data"
            :fields="fields.invoiceData"
            :form="form"
            :idPrefix="'c-'"
            :modalOpen="dialogVisible"
            :isSaving="isSaving"
            @formatDateFields="formatDateFields"
            @formChanged="updateForm"
          />
        </el-row>
      </el-col>
      <el-col :span="showProscanFile ? 24 : 8" :style="showProscanFile ? '' : 'padding-left: 10px;'">
        <el-row justify="start" align="middle" type="flex">
          <HeaderFields
            title="Transaction Info"
            :fields="fields.transactionInfo"
            :form="form"
            :lines="lines"
            :idPrefix="'e-'"
            :modalOpen="dialogVisible"
            @formChanged="updateForm"
          />
        </el-row>
        <el-row justify="start" align="middle" type="flex">
          <HeaderFields
            title="Payment Info"
            :fields="fields.paymentInfo"
            :form="form"
            :idPrefix="'d-'"
            :modalOpen="dialogVisible"
            :isSaving="isSaving"
            @formChanged="updateForm"
          />
        </el-row>
        <el-row
          justify="start"
          align="middle"
          type="flex"
          v-if="['POSTED', 'CLOSED', 'VOIDED'].includes(originalHeader.status) && checks.length === payments.length">
          <ApCheckList :checks="checks" />
        </el-row>
        <el-row
          justify="start"
          align="middle"
          type="flex"
          v-if="['POSTED', 'CLOSED', 'VOIDED'].includes(originalHeader.status)  && checks.length !== payments.length">
          <ApPaymentsList :checks="payments" />
        </el-row>
      </el-col>
        </el-row>
        </el-col>
    </el-row>
    <el-row v-if="lines" justify="start" align="middle" type="flex" id="trx-lines-container">
      <DistributionLines
        v-if="dataLoaded"
        entityType="ap"
        ref="distribution-lines"
        :fields="lineFields"
        :readOnly="readOnly || isSaving"
        :existingLines="[...originalLines]"
        :modalOpen="dialogVisible"
        :parentForm="form"
        :initLines="20"
        :vendorPoLines="vendorPoLines"
        :fetchingPoLines="fetchingPoData"
        :fieldsToClear="lineFieldsToClear"
        :hasEditPermission="hasEditPermission"
        :hasDeletePermission="hasDeletePermission"
        @viewDc="viewDc"
        @linesHaveBeenChanged="setLinesHaveBeenChanged"
        @formatMoneyFields="formatLineMoneyField"
        @lineAmountChanged="lineAmountChanged"
        @updateLines="updateLines"
        @linesInserted="handleLineInsertion"
        @mounted="setBankAttributes"
        @setApBankAttributes="setBankAttributes"
      />
      <LinesLoading v-else :distLinesHeight="distLinesHeight" />
    </el-row>
    <el-dialog
      title="Confirm cancellation"
      v-model="dialogVisible"
      width="30%"
      :show-close="false"
      :close-on-press-escape="true"
      :close-on-click-modal="false">
      <span>
        Do you wish to save your changes?
      </span>
      <template v-slot:footer><span class="dialog-footer">
        <el-button class="exit-modal-btn" @click="cancelExit">
          Cancel
        </el-button>
        <el-button class="exit-modal-btn" type="primary" @click="goBack(true)">
          No
        </el-button>
        <el-button class="exit-modal-btn" type="primary" @click="handleSubmit(false)">
          Yes
        </el-button>
      </span></template>
    </el-dialog>
    <el-dialog
      id="docs-dialog"
      title="View/Upload Documents"
      width="45%"
      top="10%"
      v-model="dropzoneVisible"
      :close-on-press-escape="true"
      :close-on-click-modal="false">
      <document-dialog
        :transaction="form"
        :dz-options="setupDropzoneOptions()"
        @upload-success="dzSuccess(); refreshProscanFiles()"
        @upload-error="dzFailure"
        @upload-remove="dzRemove"
      />
    </el-dialog>
    <NewBatch :hasCreatePermission="hasCreateBatchPermission" @populateFieldWithNewModel="populateFieldWithNewModel" />
    <CustomerVendorForm :type="customerVendorFormType" :modelId="modelId" @updateModelIdProp="updateVendorModelId" @populateFieldWithNewModel="populateFieldWithNewModel" />
    <ClosePoNotifModal
      v-model="closePoLineModalVisible"
      :poLines="underRelievedPoLines"
      :reliefStatus="reliefStatus"
      :actualPoLines="vendorPoLines"
      @closePoNotifModalVisible="handleClosePoNotifVisibility"
      @closePoLines="setSelectedPoLinesAsClosed"
    />
    <DcConfirmationDialog
      :originalLines="originalLines"
      :lineDeltas="lineDeltas"
      :lineFields="lineFields"
      v-model="dcConfirmationDialogVisible"
      :allDcs="allDcs"
      :newDcs="newDcs"
      :loading="creatingDc"
      @cancel="() => showDcConfirmationDialog(false)"
      @confirm="confirmDcSubmit"
    />
    <DcViewDialog
      :viewedDcId="viewedDcId"
      :viewableDcs="viewableDcs"
      :showOrClose="viewDc"
      :trxType="transactionType.name"
      :lineFields="lineFields"
      :trxId="originalHeader.id"
    />
  </el-col>
</template>

<script>
  /* eslint-disable camelcase */
  /* eslint-disable no-return-assign */
  import { mapGetters } from 'vuex'
  import DistributionLines from '@/components/DistributionLinesNew1.vue'
  import HeaderFields from '@/components/HeaderFields.vue'
  import NewBatch from '@/components/RouteComponents/Batches/NewBatch.vue'
  import CustomerVendorForm from '@/components/FormComponents/CustomerVendorForm.vue'
  import ApCheckList from './ApCheckList.vue'
  import ApPaymentsList from './ApPaymentsList.vue'
  import DataEntryButtons from '@/components/DataEntryButtons.vue'
  import ProscanFileViewer from '@/components/RouteComponents/Proscan/ProscanFileViewer.vue'
  import { proscanFileViewMixins } from '@/Mixins/ProscanFileView'
  import ClosePoNotifModal from './ClosePoNotifModal.vue'
  import { trackHeaderChanges, trackDistributionChanges } from '@/utils/helpers/DataEntryViews/TrackChanges'
  import { isTransactionBalanced } from '@/utils/helpers/DataEntryViews/IsTransactionBalanced'
  import { transactionMixins } from '@/Mixins/Transactions'
  import { transactionEditViewMixins } from '@/Mixins/TransactionEditViews'
  import { vendorMixins } from '@/Mixins/VendorMixins'
  import buildLabelString from '@/utils/helpers/BuildLabelString'
  import DocumentDialog from '@/components/DocumentDialog.vue'
  import LinesLoading from '@/components/LinesLoading.vue'
  import FindOrFetchBatchAndPeriod from '@/utils/helpers/DataEntryViews/FindOrFetchBatchAndPeriod'
  import DcConfirmationDialog from '@/components/DcConfirmationDialog.vue'
  import DcViewDialog from '@/components/DcViewDialog.vue'
  import store from '@/store/store'
  import { getPoLinesToRelieve, loadInitialData, getOffsetDcJeLines } from '@/utils/helpers/DataEntryViews/BeforeRouteEnterHelpers'
  
  export default {
    components: {
      DistributionLines,
      HeaderFields,
      NewBatch,
      CustomerVendorForm,
      ApCheckList,
      ApPaymentsList,
      DataEntryButtons,
      ProscanFileViewer,
      ClosePoNotifModal,
      DocumentDialog,
      LinesLoading,
      DcConfirmationDialog,
      DcViewDialog
    },
    mixins: [ transactionMixins, transactionEditViewMixins, vendorMixins, proscanFileViewMixins ],
    data () {
      const { getApById, getBatchById, getVendorById, getApLinesByTransactionId, checkIfUserHasRequiredPermissions } = this.$store.getters
      const ap = getApById(this.$route.params.id)
      const vendor = getVendorById(ap.vendor)
      let lines = this.buildLinesWithDcs(Object.values(getApLinesByTransactionId(ap.id)))
      let paymentType = ap.payment_type
      let paymentConfNumber = ap.payment_confirmation_number
      if (!checkIfUserHasRequiredPermissions(['entry.ach_payment']) && ap.payment_type === 'EFT' && ['DRAFT', 'OPEN', 'AUDITED'].includes(ap.status)) {
        paymentType = 'CHECK'
        paymentConfNumber = ''
      }
      return {
        modelId: null,
        transactionType: { name: 'ap', path: '/aps/', prettyName: 'Accounts Payable' },
        originalHeader: ap,
        originalLines: lines,
        reliefStatus: '',
        form: {
          batch: { label: getBatchById(ap.batch)?.name || '', value: ap.batch || '' },
          vendor: { label: buildLabelString(vendor), value: ap.vendor || '' },
          period: ap.period || '',
          number: ap.number || '',
          description: ap.description || '',
          date: ap.date || '',
          amount_decimal: ap.amount_decimal || '',
          discount_decimal: ap.discount_decimal || '',
          date_due: ap.date_due || '',
          payment_type: paymentType || '',
          payment_check_split: ap.payment_check_split || '',
          payment_check_pickup: ap.payment_check_pickup || false,
          payment_combine_checks: ap.payment_combine_checks || false,
          payment_confirmation_number: paymentConfNumber || '',
          bank_transaction_number: ap.bank_transaction_number || '',
          state: ap.state || '',
          status: ap.status,
          effective_date: ap.effective_date || '',
          payment_date: ap.payment_date || '',
          is_paid: ap.is_paid
        },
        lines,
        dialogVisible: false,
        readOnly: !['DRAFT', 'OPEN', 'AUDITED'].includes(ap.status) || !checkIfUserHasRequiredPermissions(['entry.view_accountspayable', 'entry.add_accountspayable']) || (['POSTED'].includes(ap.status) && !checkIfUserHasRequiredPermissions(['entry.view_accountspayable', 'entry.add_accountspayable', 'entry.post_accountspayable'])),
        createModals: { batch: { visible: false } },
        changesWereSaved: false,
        transactionIsBalanced: false,
        amountHasChanged: false,
        statusToRestore: '',
        altRoute: null,
        currentVendorSelection: '',
        ready: false,
        disableAuditBtn: false,
        disablePostBtn: false,
        closePoLineModalVisible: false,
        underRelievedPoLines: [],
        onSubmitOpts: {},
        prePoLineValidation: false,
        notificationBox: undefined,
        dropzoneVisible: false,
        paymentsVoided: false,
        payment_confirmation_number: '',
        disablePrevButton: true,
        disableNextButton: true,
        loadingPrev: false,
        loadingNext: false,
        paginationData: []
      }
    },
    methods: {
      /**
       * Updates modelId prop passed to customer create/edit modal
       */
      updateVendorModelId (id) {
        this.modelId = id
      },
      /**
       * Handles navigation when the "Back" button is hit
       */
      goBack (reset = false) {
        if (reset) this.hasBeenChanged = false
        this.ready = false
        if (this.altRoute) {
          this.$router.push(this.altRoute)
        } else {
          this.$router.push({ name: 'APs' })
        }
      },
      /**
       * Checks for PO lines that are under-relieved by checking whether the actual AP line's amount_decimal is
       * less than the original PO line's amount_decimal
       * @returns {boolean}
       */
      checkForUnderRelievedPoLines () {
        this.prePoLineValidation = false
        this.reliefStatus = ''
        this.underRelievedPoLines = this.lines.filter(line => {
          if (!(line && line.form && line.form.relieves && line.form.relieves.value > 0)) return false
          const poLineId = line.form.relieves.value
          const poLine = this.getPoLineById(poLineId)
          const lineAmt = parseFloat(line.form.amount_decimal)
          return Object.keys(poLine).length ? (lineAmt !== parseFloat(poLine.remaining_decimal)) : false
        })
        this.reliefStatus = 'Under'
        return !!(this.underRelievedPoLines && this.underRelievedPoLines.length)
      },
      /**
       * Adds the 'relieves_force_close' property to under-relieved PO lines that the user has
       * selected to be closed out
       * @param selection
       */
      setSelectedPoLinesAsClosed (selection) {
        this.closePoLineModalVisible = false
        if (selection && selection.length > 0) {
          for (let line in selection) {
            (this.lines.find((l) => parseInt(l.line_number || l.form.line_number) === parseInt(line)).form || {}).relieves_force_close = selection[line]
          }
        }
        if (!this.prePoLineValidation) {
          this.linesChanged()  // Force check or else unchanged lines (other than force closed) will be ignored.
          const { saveOnly, explicitDeltas, reportToRun } = this.onSubmitOpts
          let loaderText = 'Saving...'
          if (reportToRun === 'audit') loaderText = 'Auditing transaction...'
          if (reportToRun === 'post') loaderText = 'Posting transaction...'
          this.showTrxActionLoader(loaderText)
          this.handleSubmit(saveOnly, explicitDeltas, reportToRun)
          this.onSubmitOpts = Object.assign({})
        } else {
          this.prePoLineValidation = false
        }
        this.reliefStatus = ''
      },
      /**
       * Shows or hides the modal responsible for checking whether the user wants to close an
       * under-relieved PO line that has been imported.
       * @param visible
       */
      handleClosePoNotifVisibility (visible) {
        if (!visible) this.onSubmitOpts = Object.assign({})
        this.prePoLineValidation = false
        this.closePoLineModalVisible = visible
        this.reliefStatus = ''
      },
      /**
       * Submits the form.
       * @param saveOnly Enables or disables any navigation that should occur after the transaction is saved
       * @param explicitDeltas Specifies hard-coded deltas that need to be set, such as status
       * @param reportToRun Specifies type of report to run once saved. Can be 'audit' or 'posting'
       */
      handleSubmit (saveOnly, explicitDeltas = null, reportToRun = null) {
        if (this.$refs['distribution-lines'].errors.length) {
          this.$notify({ title: 'Error saving distribution changes', message: 'Incomplete lines', type: 'error' })
          return
        }
        if (this.shouldCreateDcJe) {
          this.showDcConfirmationDialog(true)
          this.isSaving = false
          return
        }
        if (this.dialogVisible) {
          this.handleDialogVisible(false) // Close any open dialog boxes
        }
        let removedLines = this.removeDeletedLines()
        if (this.checkForUnderRelievedPoLines() && !Object.keys(this.onSubmitOpts).length) {
          this.onSubmitOpts = Object.assign({ saveOnly, explicitDeltas, reportToRun })
          this.isSaving = false
          this.closePoLineModalVisible = true
          return
        }
        const { headerDeltas, lineDeltas } = this
        if (explicitDeltas) {
          if (explicitDeltas.status && explicitDeltas.status === 'DELETED') {
            let paginationInfo = JSON.parse(sessionStorage.getItem('paginationInfo'))
            paginationInfo = paginationInfo.filter(item => Number(item.id) !== Number(this.$route.params.id))
            sessionStorage.setItem('paginationInfo', JSON.stringify(paginationInfo))
          }
          this.headerDeltas = Object.assign(headerDeltas, explicitDeltas)
        }
        const hDeltaCount = Object.keys(headerDeltas).length
        const lDeltaCount = Object.keys(lineDeltas).length
        if (hDeltaCount || lDeltaCount) {
          this.isSaving = true
          this.saveTransactionChanges('Ap', saveOnly, reportToRun)
        } else {
          isTransactionBalanced(this)
          this.checkForChanges()
          if (removedLines.length) {
            removedLines.forEach(lineNum => this.$refs['distribution-lines'].removeLine(lineNum))
          }
        }
      },
      /**
       * Updates header form. First conditional checks if the vendor field has been changed and whether the current
       * distribution lines contain relief lines. If so, clears the 'relieves' field for each Distribution Line.
       * Second conditional sets the 'currentVendorSelection' property to the currently selected vendor.
       * @param form
       * @param changedField
       */
      async updateForm (form, changedField = null, action = null) {
        if (changedField === 'payment_confirmation_number' && form.payment_confirmation_number === null) {
          return
        }
        if (changedField === 'payment_confirmation_number') return
        this.form = { ...form }
        this.paymentDateValidation(form.date, form.payment_date, action)
        isTransactionBalanced(this)
        this.headerDeltas = trackHeaderChanges(this.form, this.originalHeader)
        if (this.headerDeltas && this.headerDeltas.hasOwnProperty('payment_confirmation_number')) delete this.headerDeltas['payment_confirmation_number']
        this.updateCheckSplitField()
        this.checkForChanges()
        if (changedField === 'number') this.checkIfTrxExists()
        else if (changedField === 'vendor') {
          this.handleVendorChange(form)
          if (this.linesContainReliefLines) {
            this.clearLineFields(['relieves'])        // check if vendor field was cleared, and if so, clear 'relieves' field in DistributionLines
          }
          if (form.number) this.checkIfTrxExists()
        } else if (changedField === 'batch') {
          this.setBankAttributeLineValues(this.bankAttributes)
        }
        if (this.form.vendor.value) {
          this.currentVendorSelection = this.form.vendor.value
        }
      },
      /**
       * When line amount changed, check for over relieved po line
       * @param line
       */
      lineAmountChanged (line) {
        this.underRelievedPoLines = []
        let activeLine = {}
        if (line.id) {
          activeLine = this.lines.find((v) => { return v.form.id === line.id })
          const apLine = this.$store.getters.getApLineById(line.id)
          if (apLine && apLine.relieves_force_close) return false
        } else {
          activeLine = this.lines.find((v) => { return v.line_number === line.line_number })
        }
        if (!activeLine || !activeLine.form) return
        const lineAmount = activeLine.form.amount_decimal
        if (activeLine.form.relieves && activeLine.form.relieves.value) {
          let poLine = this.getPoLineById(activeLine.form.relieves.value)
          if (Number(poLine.remaining_decimal) < Number(lineAmount)) {
            this.underRelievedPoLines.push(activeLine)
            this.prePoLineValidation = true
            this.reliefStatus = 'Over'
          }
        }
      },
      /**
       * Updates distribution lines
       * @param lines
       */
      updateLines (lines) {
        this.lines = lines
        this.linesChanged()
      },
      /**
       * Checks whether any changes were made to the distribution lines
       */
      linesChanged () {
        this.lineDeltas = trackDistributionChanges(this.lines, this.originalLines)
        isTransactionBalanced(this)
        this.checkForChanges()
      },
      /**
       * Open new batch or new vendor modal
       * @param type
       */
      openCreateModal (type) {
        if (type === 'vendor') {
          this.$store.dispatch('changeModalVisibility', { entityType: 'customerVendorForm', visible: true, inDataEntryView: true, type: 'vendor' })
        } else {
          this.createModals[type].visible = true
        }
      },
      /**
       * Close new batch or new vendor modal
       * @param type
       */
      closeCreateModal (type) {
        this.createModals[type].visible = false
      },
      /**
       * Updates the payment_check_split header field according to whether payment_combine_checks is
       * true or false. If true, then the check cannot be split and thus payment_check_split is
       * set to 1.
       */
      updateCheckSplitField () {
        const index = this.fields.paymentInfo.inputFields.findIndex(v => v.name === 'payment_check_split')
        if (this.form.payment_combine_checks) {
          this.fields.paymentInfo.inputFields[index].disabled = true
          this.form.payment_check_split = '1'
        } else {
          this.fields.paymentInfo.inputFields[index].disabled = false
          this.form.payment_check_split = this.form.payment_check_split ? `${this.form.payment_check_split}` : ''
        }
      },
      /**
       * Updates the status field in the header whenever the latest data for this AP hits the store
       */
      updateHeaderStatusField () {
        let tmp = Object.assign({}, this.form)
        tmp.status = this.originalHeader.status
        this.form = Object.assign({}, tmp)
      },
      /**
       * Disables specific header fields
       */
      disableHeaderFields () {
        let tmpFields = Object.assign({}, this.fields)
        tmpFields.vendor.inputFields.map(v => {
          if (v.name === 'vendor') {
            v.disabled = true
            v.addBtn = false
          }
          return v
        })
        tmpFields.batch.inputFields.map(v => {
          if (v.name === 'batch') {
            v.disabled = true
            v.addBtn = false
          }
        })
        tmpFields.invoiceData.inputFields.map(v => {
          if (v.name === 'amount_decimal') v.disabled = true
          if (v.name === 'discount_decimal') v.disabled = true
          return v
        })
        this.fields = Object.assign({}, tmpFields)
      },
      setBankAttributes () {
        let _this = this
        setTimeout(function () {
          _this.setBankAttributeLineValues(_this.bankAttributes)
        }, 100)
      },
      async handleVendorChange (form) {
        if (form.vendor.value) {
          let vendorData = this.getVendorById(form.vendor.value)
          if (!vendorData.id) {
            await this.$store.dispatch('fetchVendorById', form.vendor.value)
            vendorData = this.getVendorById(form.vendor.value)
            if (vendorData && vendorData.address_selected && vendorData.address_selected.id && vendorData.address_selected.city) {
              await this.$store.dispatch('fetchCitiesWithQuery', { id__in: [vendorData.address_selected.city], page_size: 1 })
            }
          } else {
            if (vendorData && vendorData.address_selected && vendorData.address_selected.id && vendorData.address_selected.city && typeof vendorData.address_selected.city === 'number') {
              await this.$store.dispatch('fetchCitiesWithQuery', { id__in: [vendorData.address_selected.city], page_size: 1 })
            }
          }
        }
      },
      async pageNavigation (type) {
        // Get the index of the current AP ( Current route id)
        let transactionIndex = this.paginationData.findIndex(v => parseInt(v.id) === parseInt(this.$route.params.id))
        let prevAndNextId = parseInt(this.$route.params.id)
        if (transactionIndex >= 0) {
          // Check Index is greater than zero and type is 'next'
          if (type === 'next') {
            this.loadingNext = true
            // Check upcoming Record is exist or not
            let checkNextId = this.paginationData[transactionIndex + 1]
            if (!checkNextId) {
              prevAndNextId = parseInt(this.$route.params.id)
            } else if (Object.keys(checkNextId).length) {
              prevAndNextId = checkNextId.id
            }
            // Check next id is exist or not for upcoming record and based on it we can disable the 'next' button
            this.disableNextButton = !this.paginationData[transactionIndex + 2]
          } else if (type === 'prev') {
            this.loadingPrev = true
            // Check upcoming Record is exist or not
            let checkPrevId = this.paginationData[transactionIndex - 1]
            if (!checkPrevId) {
              prevAndNextId = parseInt(this.$route.params.id)
            } else if (Object.keys(checkPrevId).length) {
              prevAndNextId = checkPrevId.id
            }
            // Check next id is exist or not for upcoming record and based on it we can disable the 'previous' button
            this.disablePrevButton = !this.paginationData[transactionIndex - 2]
          }
        }
        // Refresh the data without reloading the page
        this.refreshPage(prevAndNextId)
      },
      // Its copy of 'beforeRouteEnter': To refresh the data
      async refreshPage (routeId) {
        const { getApById } = store.getters
        try {
          store.dispatch('fetchChecksWithQuery', { related_transactions__in: [routeId] })
            .then(r => r && r.entities ? store.dispatch('findDependencies', r.entities) : [])
            .then(promises => Promise.all(promises))
            .catch(e => console.log(e))
          store.dispatch('fetchPaymentsWithQuery', { related_transactions__in: [routeId] })  // fetch attached checks
            .then(r => r && r.entities ? store.dispatch('findDependencies', r.entities) : [])
            .then(promises => Promise.all(promises))
            .catch(e => console.log(e))
          const resp = await store.dispatch('fetchCompactLineApsWithQuery', { query: { id: routeId, compact_lines: true }, storeLines: true })
          let promises = [
            store.dispatch('fetchUiSetting', { name: 'LINE_FIELD_ORDER' }),
            store.dispatch('fetchUiSetting', { name: 'CONFIRM_ON_POST' }),
            store.dispatch('fetchUiSetting', { name: 'ALLOW_PAYMENT_DATE_UPDATES' })
          ]
          if (resp && resp.entities) {
            const deps = await store.dispatch('findDependencies', resp.entities) || []
            promises = [...promises, ...deps]
          }
          await Promise.all(promises)
          const ap = getApById(routeId)
          await getPoLinesToRelieve(ap.id, 'ap')
          if (['POSTED', 'CLOSED', 'VOIDED', 'DELETED'].includes(ap.status)) {
            await getOffsetDcJeLines(routeId, 'ap')
          }
          promises = [...FindOrFetchBatchAndPeriod(store, ap)]
          if (promises.length) {
            await Promise.all(promises)
          }
          // To push the route in the URL
          if (routeId) {
            this.$router.push({ params: { id: routeId } })
          }
        } catch (e) {
          // To push the route in the URL
          if (routeId) {
            this.$router.push({ params: { id: routeId } })
          }
          console.log(e)
        }
      },
      async customCreated () {
        // To Prepare Query params to pass to the API
        const activeTab = store.getters.getActiveTab || 'all'
        let selectedStatuses = ['DRAFT', 'OPEN', 'AUDITED', 'POSTED', 'VOIDED', 'CLOSED']
        if (activeTab === 'open') {
          selectedStatuses = ['DRAFT', 'OPEN']
        }
        let paginationQuery = { status__in: selectedStatuses }
        // Fetch 'paginationQuery' data is exist or not from the session storage
        let sessionStorageQuery = sessionStorage.getItem('paginationQuery')
        // Add pagination query in the session storage
        if (sessionStorageQuery) paginationQuery = JSON.parse(sessionStorageQuery)
        // Fetch 'paginationInfo' data is exist or not from the session storage
        let validatePaginationData = JSON.parse(sessionStorage.getItem('paginationInfo'))
        let entities = []
        let response = []
        try {
          // API to get the results based on the Query
          entities = await store.dispatch('fetchApsWithQuery', paginationQuery)
          response = this.$store.getters.getAps || []

          // Check and assign the response data
          if (!validatePaginationData) {
            validatePaginationData = response.sort((a, b) => b.id - a.id)
          }
          // Check unique data is exist or not
          if (validatePaginationData) sessionStorage.setItem('paginationInfo', JSON.stringify(validatePaginationData))
          else sessionStorage.setItem('paginationInfo', JSON.stringify(response.sort((a, b) => b.id - a.id)))
          // Assign pagination info to the paginationData
          this.paginationData = JSON.parse(sessionStorage.getItem('paginationInfo'))
        } catch (error) {
          console.error()
        }
        this.disablePrevButton = false
        this.disableNextButton = false
        if (this.paginationData && this.paginationData.length > 0) {
          // To get the current index
          let getIndex = this.paginationData.findIndex(v => parseInt(v.id) === parseInt(this.$route.params.id))
          // Check index value is zero then disable prev button
          if (getIndex === 0) {
            if (entities) {
              if (!entities.previous) {
                this.disablePrevButton = true
              }
              if (!entities.next && getIndex === this.paginationData.length - 1) {
                this.disableNextButton = true
              }
              if (entities.previous) {
                paginationQuery['page'] = Number(paginationQuery['page']) - 1
                try {
                  // API to get the results based on the Quey param
                  entities = await store.dispatch('fetchApsWithQuery', paginationQuery)
                  response = this.$store.getters.getAps || []
                  let totalPaginationData = [...validatePaginationData, ...response]
                  // Update 'paginationInfo' data in the session storage
                  sessionStorage.setItem('paginationInfo', JSON.stringify(totalPaginationData.sort((a, b) => b.id - a.id)))
                  // Assign 'paginationInfo' to the 'paginationData' to do next and prev
                  this.paginationData = JSON.parse(sessionStorage.getItem('paginationInfo'))
                  sessionStorage.setItem('paginationQuery', JSON.stringify(paginationQuery))
                } catch (error) {
                  console.error()
                }
              }
            }
          } else if (getIndex === this.paginationData.length - 1) {
            // Check next available page is exist or not
            if (!entities || !entities.next) {
              this.disableNextButton = true
            } else {
              paginationQuery['page'] = Number(paginationQuery['page']) + 1
              try {
                // API to get the results based on the Quey param
                entities = await store.dispatch('fetchApsWithQuery', paginationQuery)
                response = this.$store.getters.getAps || []
                let totalPaginationData = [...validatePaginationData, ...response]
                // Update 'paginationInfo' data in the session storage
                sessionStorage.setItem('paginationInfo', JSON.stringify(totalPaginationData.sort((a, b) => b.id - a.id)))
                // Assign 'paginationInfo' to the 'paginationData' to do next and prev
                this.paginationData = JSON.parse(sessionStorage.getItem('paginationInfo'))
                sessionStorage.setItem('paginationQuery', JSON.stringify(paginationQuery))
              } catch (error) {
                console.error()
              }
            }
          }
        }
      }
      // getPaymentNumber () {
      //   let latestPayment = ''
      //   if (this.checks && this.checks.length) {
      //     latestPayment += this.checks.map(item => `${item.number} (${item.status}) `)
      //    }
      //   if(this.payments && this.payments.length) latestPayment += this.payments.map(item => `${item.number} (${item.status}) `)
      //   console.log(latestPayment, "latestPayment")
      //   this.form[`payment_confirmation_number`] = latestPayment
      // }
    },
    computed: {
      ...mapGetters({
        getCheckByRelatedTransactionId: 'getCheckByRelatedTransactionId',
        getAps: 'getAps',
        getApById: 'getApById',
        getApLineById: 'getApLineById',
        getLineById: 'getLineById',
        getApLinesByTransactionId: 'getApLinesByTransactionId',
        getApLines: 'getApLines',
        getPoLines: 'getPoLines',
        getPoLineById: 'getPoLineById',
        getVendorById: 'getVendorById',
        getPeriodById: 'getPeriodById',
        currentPeriod: 'getCurrentPeriod',
        checkIfUserHasRequiredPermissions: 'checkIfUserHasRequiredPermissions',
        checkIfUserHasAnyOfThePermissions: 'checkIfUserHasAnyOfThePermissions'
      }),
      /**
       * Returns all checks associated with this AP invoice
       */
      checks () {
        return this.$store.getters.getCheckByRelatedTransactionId(this.$route.params.id)
      },
      payments () {
        return this.$store.getters.getPaymentByRelatedTransactionId(this.$route.params.id)
      },
      /**
       * Returns the selected period
       */
      selectedPeriod () {
        const ap = this.getApById(this.$route.params.id)
        if (ap && ap.period && this.getPeriodById(ap.period).id) {
          return this.getPeriodById(ap.period)
        }
      },
      states () {
        return this.$store.getters.getAllStates.map(v => ({ label: v.name, value: v.id }))
      },
      hasReadPermission () {
        let readPermission = ['entry.view_accountspayable']
        return this.checkIfUserHasRequiredPermissions(readPermission)
      },
      hasCreatePermission () {
        return this.checkIfUserHasRequiredPermissions(['entry.view_accountspayable', 'entry.add_accountspayable'])
      },
      hasPostPermission () {
        return this.checkIfUserHasRequiredPermissions(['entry.view_accountspayable']) && this.checkIfUserHasAnyOfThePermissions(['entry.post_accountspayable', 'auth.post_transactions'])
      },
      hasEditPermission () {
        if (['POSTED', 'CLOSED'].includes(this.originalHeader.status)) return this.hasPostPermission
        else return this.hasCreatePermission
      },
      hasDeletePermission () {
        return this.hasCreatePermission && this.checkIfUserHasRequiredPermissions(['entry.delete_accountspayable'])
      },
      hasExportAchPermission () {
        return this.hasCreatePermission && this.checkIfUserHasRequiredPermissions(['entry.ach_payment'])
      },
      hasCreateBatchPermission () {
        return this.checkIfUserHasRequiredPermissions(['entry.view_batch', 'entry.add_batch'])
      },
      hasPermission () {
        return {
          read: this.hasReadPermission,
          create: this.hasCreatePermission,
          edit: this.hasEditPermission,
          delete: this.hasDeletePermission,
          post: this.hasPostPermission
        }
      },
      fields () {
        const c = this.getApById(this.$route.params.id)
        let fields = {
          vendor: {
            inputFields: [
              {
                name: 'vendor',
                label: 'Vendor',
                dataType: 'string',
                fieldType: 'input',
                autocomplete: true,
                searchAsync: true,
                required: true,
                triggerOnFocus: false,
                queryData: { endpoint: 'vendors/vendor_specific_columns', params: { active: 'True' } },
                msg: 'Please select a vendor',
                disabled: ['POSTED', 'CLOSED', 'VOIDED'].includes(c.status) || !this.hasEditPermission,
                addBtn: !['POSTED', 'CLOSED', 'VOIDED'].includes(c.status) && this.userCanCreateVendor
              }
            ],
            displayFields: [
              {
                name: 'vendor',
                label: 'Address',
                value: this.vendorAddressLine || ''
              },
              {
                name: 'vendor',
                label: 'Type',
                value: this.form.vendor.value ? this.getVendorById(this.form.vendor.value).entity_type : ''
              }
            ]
          },
          batch: {
            inputFields: [
              {
                name: 'batch',
                label: 'Batch Name',
                dataType: 'number',
                fieldType: 'input',
                autocomplete: true,
                searchAsync: true,
                required: true,
                triggerOnFocus: false,
                queryData: { endpoint: 'batches', params: { active: true } },
                msg: 'Please select a batch',
                disabled: ['POSTED', 'CLOSED', 'VOIDED'].includes(c.status) || !this.hasEditPermission,
                addBtn: !['POSTED', 'CLOSED', 'VOIDED'].includes(c.status) && this.hasCreateBatchPermission
              }
            ],
            displayFields: [
              {
                name: 'batch',
                label: 'Company',
                value: this.batchAttributes.company ? this.batchAttributes.company.name : ''
              },
              {
                name: 'batch',
                label: 'Production',
                value: this.batchAttributes.production ? this.batchAttributes.production.name : ''
              },
              {
                name: 'batch',
                label: 'Bank',
                value: this.batchAttributes.bank ? this.batchAttributes.bank.name : ''
              },
              {
                name: 'batch',
                label: 'Currency',
                value: this.batchAttributes.currency ? this.batchAttributes.currency.code : ''
              }
            ]
          },
          invoiceData: {
            inputFields: [
              {
                name: 'description',
                label: 'Description',
                dataType: 'string',
                fieldType: 'input',
                required: true,
                disabled: this.unAllowedStatusesToChange.includes(c.status) || !this.hasEditPermission,
                msg: 'Please provide a description',
                min: 3
              },
              {
                name: 'number',
                label: 'Invoice number',
                dataType: 'string',
                fieldType: 'input',
                required: true,
                disabled: this.unAllowedStatusesToChange.includes(c.status) || !this.hasEditPermission
              },
              {
                name: 'amount_decimal',
                label: 'Amount',
                dataType: 'string',
                fieldType: 'money',
                required: true,
                disabled: ['POSTED', 'CLOSED', 'VOIDED'].includes(c.status) || !this.hasEditPermission,
                isMoney: true
              },
              {
                name: 'discount_decimal',
                label: 'Discount',
                dataType: 'string',
                fieldType: 'input',
                disabled: ['POSTED', 'CLOSED', 'VOIDED'].includes(c.status) || !this.hasEditPermission,
                required: true
              },
              {
                name: 'date',
                label: 'Date',
                dataType: 'string',
                fieldType: 'date',
                required: true,
                disabled: ['CLOSED', 'VOIDED'].includes(c.status) || !this.hasEditPermission,
                msg: 'Please specify a date'
              },
              {
                name: 'date_due',
                label: 'Due Date',
                dataType: 'string',
                fieldType: 'date',
                disabled: ['CLOSED', 'VOIDED'].includes(c.status) || !this.hasEditPermission,
                msg: 'Please specify a due date'
              },
              {
                name: 'effective_date',
                label: 'Effective Date',
                dataType: 'string',
                required: this.effectiveDateMandatory,
                disabled: ['CLOSED', 'VOIDED'].includes(c.status) || !this.hasEditPermission,
                fieldType: 'date'
              },
              {
                label: 'State',
                name: 'state',
                placeholder: 'Select a state...',
                dataType: 'number',
                fieldType: 'select',
                remote: false,
                filterable: true,
                options: this.states,
                disabled: ['POSTED', 'CLOSED', 'VOIDED'].includes(c.status) || !this.hasEditPermission
              },
              {
                name: 'period',
                label: 'Period',
                dataType: 'number',
                fieldType: 'select',
                disabled: ['POSTED', 'CLOSED', 'VOIDED'].includes(c.status) || !this.hasEditPermission,
                options: [
                  { label: 'Next', value: '', selected: !(this.currentPeriod && this.currentPeriod.id) }
                ]
              }
            ]
          },
          paymentInfo: {
            inputFields: [
              {
                name: 'payment_combine_checks',
                label: 'Combine checks',
                dataType: 'boolean',
                fieldType: 'checkbox',
                disabled: ['CLOSED', 'POSTED', 'VOIDED'].includes(c.status) || !this.hasEditPermission
              },
              {
                name: 'payment_type',
                label: 'Payment type',
                dataType: 'string',
                fieldType: 'select',
                required: true,
                disabled: c.payment_processed || !this.hasEditPermission || this.isPaymentCleared,
                options: this.hasExportAchPermission ? [
                  { label: 'Check', value: 'CHECK' },
                  { label: 'Wire Transfer', value: 'WIRE' },
                  { label: 'EFT', value: 'EFT' },
                  { label: 'Manual Check', value: 'CHECK_MANUAL' },
                  { label: 'ACH', value: 'ACH', disabled: true },
                  { label: 'Direct Deposit', value: 'DD', disabled: true },
                  { label: 'N/A', value: 'NA' }
                ] : [
                  { label: 'Check', value: 'CHECK' },
                  { label: 'Wire Transfer', value: 'WIRE' },
                  { label: 'Manual Check', value: 'CHECK_MANUAL' },
                  { label: 'ACH', value: 'ACH', disabled: true },
                  { label: 'Direct Deposit', value: 'DD', disabled: true },
                  { label: 'N/A', value: 'NA' }
                ]
              },
              {
                name: 'bank_transaction_number',
                label: 'Bank Transaction #',
                dataType: 'string',
                fieldType: 'input',
                disabled: ['CLOSED', 'VOIDED'].includes(c.status) || !this.hasEditPermission,
                tooltip: "Bank's reference number for this transaction. Required for Manual Check; optionally pre-filled for EFT/Wire based on settings."
              },
              {
                name: 'payment_confirmation_number',
                label: 'Payment number',
                dataType: 'string',
                fieldType: 'input',
                // value: this.getPaymentNumber(),
                disabled: true,
                tooltip: 'Auto-assigned when this AP is processed into a payment (check, EFT, or wire).'
              },
              {
                name: 'payment_date',
                label: 'Payment Date',
                dataType: 'string',
                fieldType: 'date',
                disabled: (['CLOSED', 'VOIDED'].includes(c.status) || (this.isPaymentCleared && !this.paymentsVoided) || (['POSTED'].includes(c.status) && !this.allowPaymentDateUpdate())) || !this.hasEditPermission
              },
              {
                name: 'payment_check_split',
                label: 'Check amount split',
                dataType: 'string',
                fieldType: 'input',
                disabled: c.payment_combine_checks || !this.hasEditPermission
              },
              {
                name: 'payment_check_pickup',
                label: 'Pickup check',
                dataType: 'boolean',
                fieldType: 'checkbox',
                disabled: ['CLOSED', 'POSTED', 'VOIDED'].includes(c.status) || !this.hasEditPermission
              }
            ]
          },
          transactionInfo: {
            existingModelFields: [
              {
                label: 'Transaction #',
                value: c.ledger || ''
              },
              {
                label: 'Date created',
                value: c.created ? this.formatDateToLocale(c.created) : ''
              },
              {
                label: 'Date posted',
                value: c.time_posted ? this.formatDateToLocale(c.time_posted) : ''
              },
              {
                label: 'Status',
                value: '',
                useFormValue: true,
                field: 'status'
              },
              {
                name: 'runningTotal',
                label: 'Total Distributed',
                prefix: this.currency ? this.currency.symbol : ''
              }
            ]
          }
        }
        if (this.currentPeriod && this.currentPeriod.id) {
          fields.invoiceData.inputFields[8].options.push({ label: 'Current', value: this.currentPeriod.id })
        }
        if (this.selectedPeriod && this.currentPeriod && this.currentPeriod.id !== this.selectedPeriod.id) {
          fields.invoiceData.inputFields[8].options.push({
            label: `Ending ${this.selectedPeriod.end}`,
            value: this.selectedPeriod.id,
            selected: true
          })
        }
        return fields
      },
      isPaymentCleared () {
        if (this.checks && this.checks.length) {
          return this.checks.filter(c => c.recon).length > 0
        }
        if (this.payments && this.payments.length) {
          return this.payments.filter(p => p.recon).length > 0
        }
      },
      isRecon () {
        if (this.batchAttributes.bank) {
          let lines = Object.values(this.getApLinesByTransactionId(this.$route.params.id))
          return lines.filter(l => (l.recon !== null && (l.bank === this.batchAttributes.bank.id))).length > 0
        }
      }
    },
    watch: {
      /**
       * Watches the AP store for any new data returned by the API. When this transaction is updated,
       * the API will return a fresh copy, which will hit the store and trigger the following updates
       * to this component.
       */
      getAps () {
        const newHeader = this.getApById(this.originalHeader.id)
        if (newHeader && Object.keys(newHeader).length) {
          this.originalHeader = { ...newHeader }
          this.updateHeaderStatusField()
          this.readOnly = !['DRAFT', 'OPEN', 'AUDITED'].includes(this.originalHeader.status) || !this.hasEditPermission
        }
      },
      /**
       * Keeps an eye on which vendor is currently selected, fetches any open PO lines
       * for said vendor, and updates the PO line options in the distribution lines "relieves"
       * select dropdown.
       */
      currentVendorSelection () {
        this.getVendorOpenPoLines()
      },
      /**
       * Watches the AP store's lines property for any new or updated distribution lines.
       * This is needed in order to render offset lines created by the API on the fly.
       */
      getApLines () {
        const recent = () => {
          let incoming = Object.values(this.getApLinesByTransactionId(this.$route.params.id))
          return this.buildLinesWithDcs(incoming)
        }
        if (this.ready && (JSON.stringify(recent()) !== JSON.stringify(this.originalLines))) { // this.ready prevents this logic from running when component is created
          this.originalLines = recent()
          this.lines = recent()
          if (this.$refs && this.$refs['distribution-lines']) {
            this.$refs['distribution-lines'].rebuildLines()
          }
        }
        this.ready = !this.isSaving
      },
      /**
       * Determines whether the transaction's amount has changed
       */
      headerDeltas () {
        this.amountHasChanged = Object.keys(this.headerDeltas).includes('amount_decimal')
      }
    },
    /**
     * Things that should be done when the component is created
     */
    async created () {
      await this.customCreated()
      const { getApById } = store.getters
      isTransactionBalanced(this)
      this.updateForm(this.form)
      this.createRelievesFieldOptions()
      this.payment_confirmation_number = this.form.payment_confirmation_number
      const ap = getApById(this.$route.params.id)
      if (!ap.payment_processed) {
        store.dispatch('fetchApRelatedPaymentTransactionsWithQuery', { ap: ap.id || this.$route.params.id })
        .then((r) => {
          this.paymentsVoided = r.results.length > 0
        })
      }
    },
    /**
     * Things that should be done before the route resolves and the component is created
     * @param to
     * @param from
     * @param next
     * @return {Promise<void>}
     */
    async beforeRouteEnter (to, from, next) {
      const { getApById } = store.getters
      try {
        store.dispatch('fetchChecksWithQuery', { related_transactions__in: [to.params.id] })  // fetch attached checks
          .then(r => r && r.entities ? store.dispatch('findDependencies', r.entities) : [])
          .then(promises => Promise.all(promises))
          .catch(e => console.log(e))
        store.dispatch('fetchPaymentsWithQuery', { related_transactions__in: [to.params.id] })  // fetch attached checks
          .then(r => r && r.entities ? store.dispatch('findDependencies', r.entities) : [])
          .then(promises => Promise.all(promises))
          .catch(e => console.log(e))
        await store.dispatch('fetchCompactLineApsWithQuery', { query: { id: to.params.id, compact_lines: true }, storeLines: true }) // fetch the ap itself
        let promises = [
          store.dispatch('fetchUiSetting', { name: 'LINE_FIELD_ORDER' }),
          store.dispatch('fetchUiSetting', { name: 'CONFIRM_ON_POST' }),
          store.dispatch('fetchUiSetting', { name: 'ALLOW_PAYMENT_DATE_UPDATES' })
        ]
        // if (resp && resp.entities) {
        //   console.log(resp.entities, "resp.entities")
        //   const deps = await store.dispatch('findDependencies', resp.entities) || []
        //   console.log(deps, "sdede")
        //   // promises = [...promises, ...deps]
        // }
        await Promise.all(promises) // fetch settings and dependencies
        const ap = getApById(to.params.id)
        // Prefetch vendor so it's cached before data() builds the label (parity with batch prefetch).
        if (ap && ap.vendor) await store.dispatch('fetchVendorById', ap.vendor)
        await getPoLinesToRelieve(ap.id, 'ap')
        await loadInitialData()

        // if (['POSTED', 'CLOSED', 'VOIDED', 'DELETED'].includes(ap.status)) {
        //   await getOffsetDcJeLines(to.params.id, 'ap')
        // }
        promises = [...FindOrFetchBatchAndPeriod(store, ap)]
        if (promises.length) {
          await Promise.all(promises)
        }
        next()
      } catch (e) {
        console.log(e)
        // TODO: notify user
      }
    },
    async beforeRouteLeave (to, from, next) {
      try {
        sessionStorage.removeItem('paginationInfo')
        sessionStorage.removeItem('paginationQuery')
        await this.$store.dispatch('clearApState')
        await store.dispatch('clearPoState', true)
      } catch (e) {
        console.log(e)
      } finally {
        next()
      }
    }
  }
</script>

<style scoped>
  .h-padded {
    padding: 0 12px;
  }
  .v-padded-s {
    padding-top: 12px;
    padding-bottom: 12px;
  }
  .left-aligned-col {
    text-align: left;
  }
  .right-aligned-col {
    text-align: right;
  }
  .el-table .modified-row {
    background: #c9e5f5;
  }
  .el-form-item__label {
    padding: 20px !important;
    border: 1px solid pink;
  }
  .proscan-pane-col {
    padding-right: 12px;
    align-self: stretch;
    display: flex;
  }
  .proscan-pane {
    width: 100%;
    min-height: 420px;
  }
</style>
